'use client';

import type * as React from 'react';

import { Switch as SwitchPrimitive } from 'radix-ui';
import { twMerge } from 'tailwind-merge';

import { cs } from '@/_shared';

function Switch({
  className,
  size = 'default',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: 'sm' | 'default';
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={twMerge(
        'peer data-[state=checked]:bg-primary inline-flex h-6 w-11 shrink-0 cursor-pointer items-center border-2 border-transparent transition-colors focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 data-[state=unchecked]:bg-gray-300 dark:data-[state=unchecked]:bg-gray-600',
        'rounded-full',
        cs('rounded-full'),
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={twMerge(
          'pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
          'rounded-full',
          cs('rounded-full')
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
